import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Typography, useTheme, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useGetAgencyConfiguration, useUpdateAgencyConfiguration } from 'apis/agency/configuration/hook';
import Input from 'components/Common/Input';
import Spinner from 'components/Common/Spinner';
import { useForm } from 'react-hook-form';
import { pricingSchema } from 'utils/schema/validator/AgencyConfigureValidation';

export default function Stripe() {
  const theme = useTheme();
  const { data: configuration, isLoading } = useGetAgencyConfiguration();
  const { mutateAsync: updateConfiguration } = useUpdateAgencyConfiguration();

  const { handleSubmit, control, reset } = useForm({
    resolver: zodResolver(pricingSchema), //all fields of this page are moved in pricing
    values: { configuration: configuration }
  });

  const onSubmit = (data: any) => {
    updateConfiguration(data);
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Box>
      <Typography variant='h6'>Stripe</Typography>
      <Typography color='secondary' mt={1}>
        It helps streamlining client billing, enabling seamless payment processing and invoicing.
      </Typography>
      <Box component='form' onSubmit={handleSubmit(onSubmit)} mt={2}>
        <Grid
          container
          spacing={2}
          bgcolor={theme.palette.background.paper}
          padding={3}
          borderRadius='4px'
          border='1px solid #ECECEC'
        >
          <Grid size={6}>
            <Input name='configuration.stripe_secret_key' label='Secret Key' control={control} fullWidth />
          </Grid>
          <Grid size={6}>
            <Input name='configuration.stripe_publishable_key' label='Publishable Key' control={control} fullWidth />
          </Grid>
          <Grid size={6}>
            <Input name='configuration.stripe_webhook_secret' label='Webhook Secret' control={control} fullWidth />
          </Grid>
        </Grid>
        <Box mt={3} display='flex' gap={1} justifyContent='end'>
          <Button color='secondary' variant='outlined' sx={{ border: '1px solid #ECECEC' }} onClick={() => reset()}>
            Cancel
          </Button>
          <Button type='submit' variant='contained' color='primary'>
            Configure
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
